// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "th[data-v-3eaa9469] {\n  color: #2669a0;\n}", ""]);
// Exports
module.exports = exports;
